import React from "react";
import { Dialog, GridLegacy, Slide } from "@mui/material";
import { withStyles } from "tss-react/mui";
import notificationsStyle from "../../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import GridContainer from "../../../../components/Grid/GridContainer";
import GridItem from "../../../../components/Grid/GridItem";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import Button from "../../../../components/CustomButtons/Button";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class GetList extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth={false}
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
        scroll={"paper"}
      >
        <GridLegacy
          alignItems={"center"}
          container
          spacing={1}
          style={{ maxWidth: "98%", padding: "20px", overflowX: "hidden" }}
        >
          <h2>Terminals found</h2>
          <GridContainer alignItems={"center"} justify={"flex-end"}>
            <GridItem sm={2} xs={2}>
              <b>Brand</b>
            </GridItem>
            <GridItem sm={2} xs={2}>
              <b>Model</b>
            </GridItem>
            <GridItem sm={3} xs={3}>
              <b>Serial</b>
            </GridItem>
            <GridItem sm={3} xs={3}>
              <b>Status</b>
            </GridItem>
            <GridItem sm={2} xs={2} />
            {this.props.terminalList?.data?.data !== undefined && this.props.terminalList?.data?.data.length > 0
              ? this.props.terminalList?.data?.data.map((terminal) => {
                  return (
                    <>
                      <GridItem sm={2} xs={2}>
                        {terminal.brand}
                      </GridItem>
                      <GridItem sm={2} xs={2}>
                        {terminal.model}
                      </GridItem>
                      <GridItem sm={3} xs={3}>
                        {terminal.serialNumber}
                      </GridItem>
                      <GridItem sm={3} xs={3}>
                        {terminal.status}
                      </GridItem>
                      <GridItem sm={2} xs={2}>
                        <Button color={"success"} onClick={() => this.props.selectTerminal(terminal.id)} size={"sm"}>
                          <TranslationWrapper tDefault={"Select"} tKey={"vestigingen.button.selectTerminal"} />
                        </Button>
                      </GridItem>
                    </>
                  );
                })
              : null}
          </GridContainer>
          <Button color={"danger"} onClick={() => this.props.closeTerminalList()}>
            <TranslationWrapper tDefault={"Cancel"} tKey={"vestigingen.button.closeSelectTerminal"} />
          </Button>
        </GridLegacy>
      </Dialog>
    );
  }
}

export default withStyles(GetList, notificationsStyle);
